<template>
  <div :style="wrapperStyle">
    <label v-if="fieldLabel" class="form-field-label" :for="uniqueTitle">{{ fieldLabel }}</label>
    <b-form-textarea
      :id="uniqueTitle"
      :name="uniqueTitle"
      :placeholder="placeholder || undefined"
      :readonly="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
      @input="onInput"
    />
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'

export default {
  props: ['placeholder', 'uniqueTitle', 'fieldLabel', 'description'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, describedBy }
  },
  methods: {
    onInput (value) {
      if (this.updateFormValue) {
        this.updateFormValue(this.uniqueTitle, value)
      }
    }
  }
}
</script>
